export const GET_SOLR_RESULT = 'GET_SOLR_RESULT';
export const UPDATE_SOLR_RESULT = 'UPDATE_SOLR_RESULT';
export const TOGGLE_SOLR_FACET = 'TOGGLE_SOLR_FACET';
export const SET_SOLR_TYPE_PARAMS = 'SET_SOLR_TYPE_PARAMS';
export const SET_SOLR_SEARCH = 'SET_SOLR_SEARCH';

export const SHOW_USER_DETAILS = 'SHOW_USER_DETAILS';
export const HIDE_USER_DETAILS = 'HIDE_USER_DETAILS';

export const CREATE_SOLR_COLLECTION = 'CREATE_SOLR_COLLECTION';
export const DELETE_SOLR_COLLECTION = 'DELETE_SOLR_COLLECTION';
export const GET_SOLR_COLLECTIONS = 'GET_SOLR_COLLECTIONS';

export const GET_HIDDEN_BLOCK_TYPES = 'GET_HIDDEN_BLOCK_TYPES';
export const TOGGLE_HIDDEN_BLOCK_TYPE = 'TOGGLE_HIDDEN_BLOCK_TYPE';

// @plone-collective/volto-bookmarks
export const GET_BOOKMARKS = 'GET_BOOKMARKS';
export const GET_BOOKMARK = 'GET_BOOKMARK';
export const ADD_BOOKMARK = 'ADD_BOOKMARK';
export const PUT_BOOKMARK = 'PUT_BOOKMARK';
export const DEL_BOOKMARK = 'DEL_BOOKMARK';

export const GET_NEWEST_COMMENTS = 'GET_NEWEST_COMMENTS';

export const GET_PINS = 'GET_PINS';
